<template>
	<div id="content-map">
		<ol-map-container
			name="theMap"
			:latitude="latitude ? latitude : '4.671469'"
			:longitude="longitude ? longitude : '-74.073240'"
			:zoom="zoom ? zoom : '12'"
			:width="width ? width : widthMap"
			:height="height ? height : '100vh'"
			:mapType="mapType"
			@instanceOlMap="olMap = $event"
		>
		</ol-map-container>
		<georreferencer v-if="isGeoActive" class="map-top-right-possition" />
	</div>
</template>

<script>
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleZonification from "@/store/zonification/moduleZonification.js";
import VisitPoint from "@/models/VisitPoint.js";
import Zone from "@/models/zone.js";
import visitPointImg from "@/assets/images/markers/visit_point.png";
import InfowindowVisitPoint from "@/components/Maps/InfowindowVisitPoint.vue";
import Vue from "vue";
import Georreferencer from "../Maps/Georreferencer";
import firebase from "firebase/app";
import Infowindow from "../Maps/Infowindow";
import OlMapContainer from "../../core/components/ol/OlMap";
import mapMethods from "../Maps/mapMethods";
import carto from "@carto/carto.js";
import cartodb from "@/constants/cartodb.js";
import cartoDB from "@/helpers/cartoDB";

import {
	addCartoDb,
	addMarker,
	centerMap,
	drawCircle,
	fitBounds,
	fitBoundsMarkerGroup,
	getZoom,
	removeTileLayers,
	setZoom,
} from "../../core/plugins/ol/OlAnuket";
import {
	generateInfowindowContentVisitPoints,
	infowindowContentResource,
	infowindowContentResourceOnDemand,
} from "../Maps/infowindowContent";
import {fromLonLat, transform} from "ol/proj";

let ComponentClass = Vue.extend(InfowindowVisitPoint);
let ComponentClassResourceActive = Vue.extend(Infowindow);
const {cartoTable} = cartodb;

export default {
	name: "MapViewOnDemand",
	components: {
		OlMapContainer,
		InfowindowVisitPoint,
		Georreferencer,
	},
	props: {
		name: {
			type: String,
			required: true,
			default: "themap",
		},
		latitude: {
			type: String,
			required: false,
			default: "51.51455",
		},
		longitude: {
			type: String,
			required: false,
			default: "-0.07306",
		},
		zoom: {
			type: String,
			required: false,
			default: "12",
		},
		mapType: {
			type: String,
			required: true,
			default: "here",
		},
		width: {
			type: String,
			required: false,
			default: null,
		},
		height: {
			type: String,
			required: false,
			default: null,
		},
		markerData: {
			type: Array,
			default: () => [],
		},
		calledFrom: {
			type: String,
			required: false,
			default: "maps",
		},
		// Propiedad creada para integrar con modulo OnDemandHistory.vue
		onDemandEvent: {
			type: Object,
			default: () => null,
		},
		OnDemandPolygonZones: {
			type: Array,
			default: () => [],
		},
		addResourceMarkerTrigger: 0,
		showResourceMarkerTrigger: 0,
		hiddeResourceMarkerTrigger: 0,
	},
	data() {
		return {
			olMap: null,
			numDeltas: 100,
			delay: 10,
			currentPosition: {},
			deltaLat: null,
			deltaLng: null,
			database: firebase.database(),
			active: false,
			instanceInfo: null,
			visitPoint: new VisitPoint({}),
			selectedZone: new Zone({}),
			cartoLayerIds: [],
			resourceMarkers: [],
			onDemandResourceTracking: null,
			positionArray: [],
			client: cartoDB.client(),
		};
	},
	created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleZonification.isRegistered) {
			this.$store.registerModule("moduleZonification", moduleZonification);
			moduleZonification.isRegistered = true;
		}
	},
	mounted() {
		const zoom = document.querySelector(".H_l_bottom");
		if (zoom != null) {
			zoom.setAttribute("style", "left: 60px");
		}
		// Esto se ejecuta cuando se hace click en el mapa desde el historial de ondemand
		if (this.calledFrom === "onDemand" && this.markerData.length > 0) {
			this.getResourceTracking(this.markerData[0]).then((response) => {
				this.onDemandResourceTracking = response;
				if (this.onDemandResourceTracking) {
					const {cx, cy, active} = this.onDemandResourceTracking;
					if (active) {
						this.addMarkerResourceOndemand(
							parseFloat(cy),
							parseFloat(cx),
							this.markerData[0],
							this.onDemandResourceTracking
						);
						this.addMarkerVisitPoint(
							{...this.onDemandEvent, name: this.onDemandEvent.visit_point_name},
							false
						);
						this.listenOnDemandResourceTracking(this.markerData[0]);
						setTimeout(() => {
							fitBoundsMarkerGroup(this.resourceMarkers);
						}, 500);
					}
				}
			});
		}
	},
	beforeDestroy() {
		this.$store.commit("moduleMap/SET_MODULE_TYPE", null);
		this.$store.dispatch("moduleMap/closePopupRouteLegends", false);
		this.$store.commit("moduleMap/CLEAR_ZONE_GEOCERCA");
	},
	watch: {
		addResourceMarkerTrigger() {
			this.markerData.forEach((resource) => {
				this.addMarkerResource(resource);
			});
			this.$emit("getResourceMarkersEmit", this.resourceMarkers);
		},
		hiddeResourceMarkerTrigger() {
			this.resourceMarkers.forEach((marker) => {
				marker.setVisible(false);
			});
			this.resourceMarkers = [];
		},
		removeResourceLayerTrigger() {
			this.clearPolygons();
		},
	},
	computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		isGeoActive() {
			return this.$store.state.moduleMap.toggleGeorreferencer;
		},
		widthMap() {
			let widthValue = "";
			if (this.$store.state.reduceButton && this.windowWidth > 1200) {
				widthValue = "94vw";
			} else if (this.windowWidth > 1200) {
				widthValue = "80vw";
			} else {
				widthValue = "100vw";
			}
			return widthValue;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		addMarkerResource(resource_data, title = this.$t("MapModule.CurrentPosition")) {
			// Opciones
			let options = {
				drag: false,
				icon: mapMethods.generateMarkerIconResource({active: true}),
				title: resource_data.username || title,
				activatePopup: true,
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				info: resource_data,
				infoWindow: {
					content: infowindowContentResource.call(this, resource_data, this.btnCallbackClick),
				},
				onClick: (e) => {
					if (this.calledFrom === "onDemand") {
						const resourceRelatedZones = this.getRelatedZonesResourceOnDemand(e);
						if (resourceRelatedZones.length > 0) this.drawCartoPolygonsOnDemand(resourceRelatedZones);
					}
				},
				onClose: () => {
					if (this.calledFrom === "onDemand") {
						this.clearPolygons();
					}
				},
			};
			const resourceMarker = addMarker({lat: resource_data.cy, lng: resource_data.cx}, options);
			this.olMap.ol.addLayer(resourceMarker);
			this.resourceMarkers.push(resourceMarker);
		},
		getResourceMarkers() {
			return this.resourceMarkers;
		},
		btnCallbackClick(data) {
			this.$emit("assignResourceToEventConfirmEmit", data);
		},
		addMarkerVisitPoint(visitPoint, draggable = true, title = this.$t("MapModule.CurrentPosition")) {
			this.visitPoint = visitPoint;
			const lat = visitPoint.cy,
				lng = visitPoint.cx;
			let options = {
				drag: draggable,
				icon: visitPointImg,
				title,
				activatePopup: true,
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content: generateInfowindowContentVisitPoints(this.visitPoint),
				},
				onDragend: (e, coords) => {
					this.visitPoint.cy = parseFloat(coords.lat).toFixed(8);
					this.visitPoint.cx = parseFloat(coords.lng).toFixed(8);
					this.$emit("geoInversoEmit", {
						country: this.visitPoint.country,
						cy: coords.lat,
						cx: coords.lng,
					});
				},
			};
			const marker = addMarker({lat, lng}, options);
			this.olMap.ol.addLayer(marker);
			this.positionArray.push({lat, lng});
			if (this.onDemandEvent) {
				this.resourceMarkers.push(marker);
			} else {
				centerMap([lng, lat], 12);
			}
		},
		addMarkerResourceOndemand(lat, lng, resource, resourceTracking) {
			this.currentPosition = {lat, lng};
			// Opciones
			let options = {
				drag: false,
				icon: mapMethods.generateMarkerIconResource(resourceTracking),
				title: this.$t("MapModule.CurrentPosition"),
				activatePopup: true,
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				info: resourceTracking,
				infoWindow: {
					content: infowindowContentResourceOnDemand(resource),
				},
			};
			const marker = addMarker({lat, lng}, options);
			this.positionArray.push({lat, lng});
			this.resourceMarkers.push(marker);
			this.olMap.ol.addLayer(marker);
		},
		createCircle(coordinates, radius = 200) {
			const circle = drawCircle(coordinates, radius, null);
			this.olMap.ol.addLayer(circle);
		},
		getResourceTracking(resource) {
			const starCountRef = this.database.ref(
				"tracking/" + resource.company_id + "/" + resource.positionrecord_id
			);
			return new Promise(async (resolve, reject) => {
				starCountRef.once("value", (snapshot) => {
					const resourceTracking = snapshot.val();
					if (resourceTracking) {
						resolve(resourceTracking);
					} else {
						reject("Error");
					}
				});
			});
		},
		/**
		 * TODO: Escuchar los cambios del tracking de un recurso
		 * ? Funcion creada para integrar con modulo OnDemandHistory.vue
		 * @param {Object} resource
		 */
		listenOnDemandResourceTracking(resource) {
			const starCountRef = this.database.ref(
				"tracking/" + resource.company_id + "/" + resource.positionrecord_id
			);
			starCountRef.on("value", (snapshot) => {
				const resourceTracking = snapshot.val();
				if (resourceTracking) {
					const {active, resource_id, cx, cy} = resourceTracking;
					if (active) {
						const foundResource = this.resourceMarkers.find(({info}) => +info.resource_id === +resource_id);
						if (foundResource && foundResource.cy !== +cy) {
							this.updateOnDemandMarkerPosition(foundResource, +cy, +cx);
						}
					}
				}
			});
		},
		/**
		 * TODO: Actualizar la posicion del marker con un efecto de movimiento
		 * ? Funcion creada para integrar con modulo OnDemandHistory.vue
		 * @param {Here Maps Marker} marker capturado para actualizar
		 * @param {Float} newLat Nueva posicion en latidud del marker
		 * @param {Float} newLng Nueva posicion en longitud del marker
		 */
		updateOnDemandMarkerPosition(marker, newLat, newLng) {
			let i = 0;
			const deltas = 100;
			let feature = marker.getSource().getFeatures()[0];
			const geometryCoords = feature.getGeometry().transform("EPSG:3857", "EPSG:4326");
			let currentPositionLat = parseFloat(geometryCoords.getCoordinates()[1]);
			let currentPositionLng = parseFloat(geometryCoords.getCoordinates()[0]);
			const deltaLat = (newLat - currentPositionLat) / deltas;
			const deltaLng = (newLng - currentPositionLng) / deltas;
			const moveFeature = (evt) => {
				currentPositionLat += deltaLat;
				currentPositionLng += deltaLng;
				if (isNaN(currentPositionLat)) return;
				geometryCoords.setCoordinates(fromLonLat([currentPositionLng, currentPositionLat]));
				while (i <= deltas) {
					i++;
					setTimeout(moveFeature, 10);
				}
			};
			moveFeature();
		},
		getRelatedZonesResourceOnDemand(markerEvent) {
			const resource = this.markerData.find((element) => element.id === markerEvent.info.id);
			if (resource && Object.hasOwn(resource, "related_zone")) {
				const resourceZones = this.OnDemandPolygonZones.filter((zone) =>
					resource.related_zone.includes(+zone.cartodb_id)
				);
				return resourceZones;
			}
			return [];
		},
		zoomBounds(cartodbIds) {
			cartoDB
				.executeQueryWithBounds(
					`WITH bbox as (SELECT ST_Envelope(the_geom) as the_geom FROM ${cartoTable} WHERE cartodb_id IN (${cartodbIds}))
                SELECT the_geom, ST_Xmax(the_geom) as xmax,
                ST_Ymax(the_geom) as ymax,
                ST_Xmin(the_geom) as  xmin,
                ST_Ymin(the_geom) as ymin
                FROM bbox`
				)
				.then((res) => {
					let geoJson = res.data["features"][res.data["features"].length - 1];
					const minLon = geoJson["properties"]["xmin"];
					const minLat = geoJson["properties"]["ymin"];
					const maxLon = geoJson["properties"]["xmax"];
					const maxLat = geoJson["properties"]["ymax"];
					const extent = [minLon, minLat, maxLon, maxLat];
					fitBounds(extent, "Features");
				})
				.catch((err) => {
					console.error(err);
				});
		},
		drawCartoPolygonsOnDemand(dataLayer) {
			const options = {
				polygonFill: "#FF5C00",
				lineColor: "#FF5C00",
			};
			const cartodbIds = dataLayer.map(({cartodb_id}) => cartodb_id);
			const source = new carto.source.SQL(`SELECT * FROM ${cartoTable} WHERE cartodb_id IN (${cartodbIds})`);
			// Create style for the data
			const style = new carto.style.CartoCSS(`#layer {
				polygon-fill: ${options.polygonFill};
				polygon-opacity: 0.5;
				line-color: ${options.lineColor};
				line-width: 0.5;
				line-opacity: 1;
				line-dasharray: 10, 5;
			}
			`);
			// Add style to the data
			const layer = new carto.layer.Layer(source, style, {
				featureClickColumns: ["name", "layer", "description", "cartodb_id"],
			});
			this.renderCartoLayerOnDemand(layer, cartodbIds);
		},
		async renderCartoLayerOnDemand(layer, cartodbIds) {
			await this.clearCartoPolygonsOnDemand();
			// Modificamos el zoom del mapa para que las layer no se queden pegadas en el mapa
			const mapZoom = getZoom();
			setZoom(mapZoom - 1);
			this.client.addLayer(layer);
			let options = {
				title: this.$t("MapModule.CurrentPosition"),
				activatePopup: true,
				onClick: (e) => {
					this.selectedZone = new Zone(e.info);
				},
				onClose: () => {
					this.selectedZone = new Zone({});
				},
			};
			await addCartoDb(layer.getSource().getQuery(), options);
			this.zoomBounds(cartodbIds);
		},
		clearCartoPolygonsOnDemand() {
			return new Promise(async (resolve, reject) => {
				const layers = this.client.getLayers();
				if (layers.length > 0) {
					const removeLayerFetches = layers.map((layer) => {
						this.client.removeLayer(layer);
						removeTileLayers();
					});
					const res = await Promise.allSettled(removeLayerFetches);
					resolve(res);
				} else {
					resolve([]);
				}
			});
		},
		clearPolygons() {
			const layers = this.client.getLayers();
			let i = 0;
			while (layers.length > 0) {
				this.client
					.removeLayer(layers[i])
					.then(() => {
						removeTileLayers();
						setTimeout(() => {
							fitBoundsMarkerGroup(this.resourceMarkers);
						}, 500);
						i++;
					})
					.catch((cartoError) => {
						i++;
						console.error(cartoError);
					});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/rutify/settings/_colors.scss";
/** custom content for map */
.map-custom-container {
	margin-top: calc(100% - 102%);
	margin-left: -35px;
	margin-right: -35px;
	height: 88vh;
}

.street-vien-container {
	width: 100%;
	height: 40vh;
}

@media (min-width: 1400px) {
	.map-custom-container {
		margin-top: calc(100% - 102%);
		height: 93vh;
	}

	.street-vien-container {
		width: 100%;
		height: 60vh;
	}
}

@media (max-width: 992px) {
	.map-custom-container {
		margin-top: calc(100% - 109%);
		height: 89vh;
	}

	.street-vien-container {
		width: 100%;
		height: 40vh;
	}
}

@media (max-width: 575px) {
	.map-custom-container {
		margin-left: -20px;
		margin-right: 0;
	}
}

.customizer-btn-map-opc {
	position: fixed;
	background: $orange !important;
	width: 40px !important;
	height: 50px !important;
	top: 50%;
	right: 1%;
	border-radius: 5px;
	z-index: 50000;
	clear: both;
}

.customizer-btn-map-clear {
	position: fixed;
	background: $orange !important;
	width: 40px !important;
	height: 45px !important;
	top: 45%;
	right: 1%;
	border-radius: 5px;
	z-index: 50000;
	clear: both;

	&:after {
		content: "";
		position: absolute;
		width: 1.5em;
		height: 0.6px;
		top: 2.3em;
		left: 0.4em;
		background: white;
	}
}

.map-top-right-possition {
	position: fixed;
	top: 69px;
	right: 100px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-top-left-possition {
	position: fixed;
	top: 100px;
	left: 270px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-top-left-possition-reducce-button {
	position: fixed;
	top: 100px;
	left: 90px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}
</style>
